export const Font = {
  Primary: 'Mulish, Arial, sans-serif',
};
